import { Fragment } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { BasicDropdownTitle } from "../../../Constants/Constants";
import { BasicDropdownData, BasicDropdownSubTitle } from "../../../Data/UiKits/Dropdown";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import DropdownCommon from "./Common/DropdownCommon";

const BasicDropdown = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={BasicDropdownTitle} span={BasicDropdownSubTitle} />
        <CardBody className="rtl-dropdown">
          <div className="common-flex">
            {BasicDropdownData &&
              BasicDropdownData.map((item, index) => (
                <Fragment key={index}>
                  <DropdownCommon item={item} />
                </Fragment>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BasicDropdown;
